export enum AuthMethod {
  PHONE = 'phone',
  AUTH0 = 'auth0',
}
